import { Footer } from "../../../components/Footer/Footer";
import Header from "../../../components/header/header";
import { MenuBottom } from "../../../components/MenuBottom/MenuBottom";
import { AdminBasePage } from "../AdminBase";
import { AdminMenu } from "../components/AdminMenu";
import { PreviewJob } from "../components/PreviewJob";

const AdmExecutorPage = () => {
  return (
    <AdminBasePage>
      <div className="body">
        <Header></Header>
        <div className="blocks blocks-row">
          <div className="block-left">
            <AdminMenu></AdminMenu>
          </div>
          <div className="block-right">
            <PreviewJob />
          </div>
        </div>
        <Footer></Footer>
        <MenuBottom></MenuBottom>
      </div>
    </AdminBasePage>
  );
};

export default AdmExecutorPage;
